/**
 * Actieve winkel uit een access-token lezen (enkel de payload decoderen, géén verificatie — die doet
 * de server). Gebruikt om tabbladen in sync te houden: alle tabbladen delen localStorage, dus als een
 * ander tabblad van winkel wisselt, werkt dit tabblad voortaan in die winkel (Sanju 28/10: bovenbalk
 * toonde Mechelen terwijl de sessie op Boortmeerbeek stond).
 */
export function winkelUitToken(token: string | null | undefined): string | null {
  const deel = token?.split('.')[1];
  if (!deel) return null;
  try {
    const json = atob(deel.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(deel.length / 4) * 4, '='));
    const p = JSON.parse(json) as { entityId?: unknown };
    return typeof p.entityId === 'string' ? p.entityId : null;
  } catch {
    return null;
  }
}
